import { render, staticRenderFns } from "./ExibirLabLogins.vue?vue&type=template&id=647b4cd8&"
import script from "./ExibirLabLogins.vue?vue&type=script&lang=js&"
export * from "./ExibirLabLogins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports